<template>
	<LimitableActionValidator
		:limits-to-check="limitsToCheck"
		:validation-threshold-overrides="validationThresholdOverrides"
		:resource-usage-overrides="resourceUsageOverrides"
		:error-on-undefined-usage="errorOnUndefinedUsage"
		@valid-click="validClickHandler"
		@invalid-click="invalidClickHandler"
	>
		<template #clickTarget>
			<TooltipButton v-bind="{ ...$attrs }">
				<template #btnContent>
					<slot name="btnContent" />
				</template>
				<template
					v-if="$slots.tooltipContent"
					#tooltipContent
				>
					<slot name="tooltipContent" />
				</template>
			</TooltipButton>
		</template>
	</LimitableActionValidator>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

// Types
import { UserLimits } from "@/js/tierconfig";

// Components
import LimitableActionValidator from "@/components/Common/LimitableActionValidator.vue";
import TooltipButton from "@/components/Common/TooltipButton.vue";

export default defineComponent({
	name: "LimitableActionButton",
	components: { LimitableActionValidator, TooltipButton },
	inheritAttrs: false,
	emits: {
		"valid-click": () => true,
		"invalid-click": (_violatedLimits: UserLimits[]) => true,
	},
	props: {
		limitsToCheck: { type: Array as PropType<UserLimits[]>, default: () => [] },
		validationThresholdOverrides: { type: Array as PropType<any[]>, default: () => [] },
		resourceUsageOverrides: { type: Array as PropType<any[]>, default: () => [] },
		errorOnUndefinedUsage: { type: Boolean, default: false },
	},
	methods: {
		validClickHandler() {
			if (!this.$attrs.disabled) {
				this.$emit("valid-click");
			}
		},
		invalidClickHandler(exceededLimits) {
			if (!this.$attrs.disabled) {
				this.$emit("invalid-click", exceededLimits);
			}
		},
	},
});
</script>
